import styled from "styled-components";

export const TitleReserveStyled = styled.div`
  font-size: ${({ theme }) => theme.FONT.SIZE.S14};
  font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
  color: ${({ theme }) => theme.COLORS.PURPLE_1};


  &.theme_text_black {
    color: ${({ theme }) => theme.COLORS.BLACK_4};
}
`;

